import request from "@/helper/request";
import CryptoJS from "crypto-js";

export function adminLogin({ username, password }) {
    // 对密码做去空格 + MD5 加密
    const md5Password = CryptoJS.MD5(password.trim()).toString();
  
    return request({
      url: "/api/adminLogin/",
      method: "post",
      data: {
        username: username.trim(),
        password: md5Password
      }
    });
  }